import React from 'react';

// Four-point sparkle (iconoir spark-solid). Fills its container so callers
// size it with CSS rather than shipping one asset per size.
export default function Spark() {
  return <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 20C15.4467 20 20 15.605 20 5C20 15.605 24.5217 20 35 20C24.5217 20 20 24.5217 20 35C20 24.5217 15.4467 20 5 20Z" fill="#FFA500"/>
    </svg>
}
